import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import moment from 'moment'

import styles from './article-preview.module.css'

function displayDate(thisDate) {
  return moment(thisDate).format("DD MMM YYYY");
}

export default ({ news }) => (
  <Link to={`/news/${news.slug}`}>
    <div className={styles.cardItem}>
      <Img alt={news.title} sizes={news.heroImage.sizes} className={styles.cardImage} />
      <div className={styles.cardInfo}>
        <div className={styles.cardDate}><small >{displayDate(news.publishDate)}</small></div>
        <h3 className={styles.cardTitle}>{news.title}</h3>
        <div className={styles.cardExcerpt}>{news.excerpt}</div>
      </div>
    </div>
  </Link>
)



// WEBPACK FOOTER //
// ./src/components/news-preview.js